module.exports = __webpack_public_path__ + "img/smart1.281eaf68.png";